import { useNavigate } from "react-router-dom";
import OfferForm from "components/offers/OffersForm";
import useOffers  from "components/offers/hooks/useOffers";
import Alert from "components/common/Alert";
import { useState } from "react";

export default function CreateOffer() {
  const navigate = useNavigate();
  const { addOffer } = useOffers();
  const [alert, setAlert] = useState(null);

  const userId = "69579c6190a653b640e65639";
  const companyId = localStorage.getItem("company_id");

  return (
    <>
      {alert && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}

      <OfferForm
        onSubmit={async (fd) => {
          try {
            fd.append("company_id", companyId);
            fd.append("created_by", userId);

            await addOffer(fd);
            navigate("/admin/offers");
          } catch (error) {
            setAlert({
              type: "error",
              message:
                error.response?.data?.message ||
                "Failed to create offer",
            });
          }
        }}
        onBack={() => navigate("/admin/offers")}
      />
    </>
  );
}
